import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Carousel, ConfigProvider, Radio } from 'antd'
import Image from 'next/image'
import { Icon } from '@iconify/react'
import Link from 'next/link'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'
import { message } from 'antd'
import styles from './PermissionDescription.module.scss'
import { messageInfo } from 'src/components/Message'

const options = [
  { label: 'Samsung/Google/Motorola/Others', value: '0' },
  { label: 'XiaoMi', value: '1' }
]

function One(data) {
  const { t } = useTranslation('commonAndroid')

  const [phoneModel, setPhoneModel] = useState('0')
  const step1 = useMemo(
    () => [
      {
        title: t('Allow&nbsp;<strong>Appear on top</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/1.1.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Installed apps</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.1.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Update service</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.2.jpg'
          }
        ]
      },
      {
        title: t('Turn on&nbsp;<strong>Update service</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.3.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Allow</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.4.jpg'
          }
        ]
      },
      {
        title: t('Settings > Apps Settings > Apps > Manage apps (some models)'),
        img: [
          {
            src: '/images/android/permissiondescription/2.1.png'
          }
        ]
      },
      {
        title: t('Find and Tap&nbsp;<strong>Update service</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/2.2.png'
          }
        ]
      },
      {
        title: t('Tap on the 3 dots in the upper right corner'),
        img: [
          {
            src: '/images/android/permissiondescription/2.3.png'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Allow restricted settings</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/2.4.png'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Permissions</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/4.1.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Location > Allow all the time</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/4.2.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Activate</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/4.3.jpg'
          }
        ]
      }
    ],
    [t]
  )
  const step2 = useMemo(
    () => [
      {
        title: t('Allow&nbsp;<strong>Appear on top</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/1.1.jpg'
          }
        ]
      },

      {
        title: t('Tap&nbsp;<strong>Installed apps</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.1.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Update service</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.2.jpg'
          }
        ]
      },
      {
        title: t('Turn on&nbsp;<strong>Update service</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.3.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Allow</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/3.4.jpg'
          }
        ]
      },
      {
        title: t('Settings > Apps > Manage apps'),
        img: [
          {
            src: '/images/android/permissiondescription/2.1(xiaomi).jpg'
          }
        ]
      },
      {
        title: t('Find and Tap&nbsp;<strong>Update service</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/2.2(xiaomi).jpg'
          }
        ]
      },
      {
        title: t('Turn on&nbsp;<strong>Allow restricted settings</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/2.3(xiaomi).jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>No restrictions</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/2.4(xiaomi).jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Permissions</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/4.1.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Location > Allow all the time</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/4.2.jpg'
          }
        ]
      },
      {
        title: t('Tap&nbsp;<strong>Activate</strong>'),
        img: [
          {
            src: '/images/android/permissiondescription/4.3.jpg'
          }
        ]
      }
    ],
    [t]
  )
  const [step, setStep] = useState(step1)

  const imgToggle = useRef()

  const [currentSlide, setcurrentSlide] = useState(0)

  const [carousel, setCarousel] = useState(step[0].img)

  const [autoplay, setAutoplay] = useState(true)

  useEffect(() => {
    if (phoneModel === '0') {
      setStep(step1)
    } else {
      setStep(step2)
    }
    setCarousel(step[0].img)
    setcurrentSlide(0)
    setImg(0)
    imgToggle.current.goTo(0)
  }, [phoneModel, step, step1, step2])

  const Handler = index => {
    if (index !== 13) {
      setCarousel(step[index].img)
      setcurrentSlide(index)
      setImg(0)

      imgToggle.current.goTo(0)

      /* imgToggle.current.goTo(index) */
    } else {
      /* imgToggle.current.goTo(0) */
      setCarousel(step[index].img)
      setcurrentSlide(index)
    }
  }

  const { query } = useRouter()

  const [a, setA] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoplay === true) {
        if (parseInt(currentSlide) === 11) {
          setCarousel(step[0].img)
          setcurrentSlide(0)
          setImg(0)
          imgToggle.current.goTo(0)
        } else {
          setCarousel(step[currentSlide + 1].img)
          setcurrentSlide(currentSlide + 1)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      }
    }, [parseInt(currentSlide) !== 11 ? 4000 : 11000])

    // 清除定时器以避免内存泄漏
    return () => clearInterval(interval)
  }, [currentSlide, carousel, query, a, autoplay])

  const [Img, setImg] = useState(0)

  useEffect(() => {
    let startX

    const handleTouchStart = e => {
      // 记录触摸起始位置
      startX = e.touches[0].clientX
    }

    const handleTouchMove = e => {
      // 计算触摸移动距离
      e.preventDefault()

      const currentX = e.touches[0].clientX
      const deltaX = currentX - startX

      // 根据 deltaX 判断左右滑动
      if (deltaX > 0) {
        if (parseInt(currentSlide) === 0) {
          setCarousel(step[11].img)
          setcurrentSlide(11)
          setImg(0)
        } else {
          setCarousel(step[currentSlide - 1].img)
          setcurrentSlide(currentSlide - 1)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      } else if (deltaX < 0) {
        if (parseInt(currentSlide) === 10) {
          if (parseInt(Img) + 1 === carousel.length) {
            setCarousel(step[currentSlide + 1].img)
            setcurrentSlide(currentSlide + 1)
            setImg(0)
            imgToggle.current.goTo(0)
          }
        } else if (parseInt(currentSlide) === 11) {
          if (parseInt(Img) + 1 === carousel.length) {
            setCarousel(step[0].img)
            setcurrentSlide(0)
            setImg(0)
            imgToggle.current.goTo(0)
          }
        } else {
          setcurrentSlide(currentSlide + 1)
          setCarousel(step[currentSlide + 1].img)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      }
    }

    // 添加事件监听器
    document.addEventListener('touchstart', handleTouchStart)
    document.addEventListener('touchmove', handleTouchMove)

    // 清理工作
    return () => {
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
    }
  }, [currentSlide, carousel, query, a, Img])

  const [copy, setCopy] = useState(false)

  const [messageApi, contextHolder] = message.useMessage()

  const success = () => {
    messageInfo({
      type: 'success',
      content: 'Copied'
    })
  }

  const onChange = ({ target: { value } }) => {
    setPhoneModel(value)
  }

  return (
    <div
      className={`w-[620px] Ssm:w-[100%] overflow-x-hidden overflow-auto h-[100%] mx-auto justify-between setup ${data.fullScreen ? 'grid xs:pb-[0px]' : 'Smd:flex overflow-hidden xs:pb-[70px] h-[99%]'
        }`}
    >
      {contextHolder}
      {data.fullScreen && (
        <Icon
          onClick={() => {
            data.setFullScreen(false)
          }}
          icon='0maki:cross'
          className={`absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
        />
      )}
      <div
        onMouseEnter={() => {
          setAutoplay(false), setA(0)
        }}
        onMouseLeave={() => {
          setAutoplay(true), setA(1)
        }}
        className={`w-full text-black Ssm:w-[100%] mx-auto justify-between setup ${data.fullScreen ? 'grid mx-auto' : ' Smd:flex Dsm:mt-[30px] justify-between'
          }`}
      >
        <div
          className={`w-[353px] ${data.fullScreen ? 'order-2 !w-[80%] mx-auto mt-[20px]' : 'Dsm:w-[100%] Ssm:mx-auto'}`}
        >
          <ConfigProvider
            theme={{
              token: {
                // Seed Token，影响范围大
                colorPrimary: '#12D8AB'

                // colorBgContainer: '#f6ffed'
                // borderRadius: 2
                // 派生变量，影响范围小
              }
            }}
          >
            <Radio.Group
              className={`${styles.box} mb-[20px]`}
              options={options}
              onChange={onChange}
              value={phoneModel}
              optionType='button'
              buttonStyle='solid'
            />
          </ConfigProvider>
          <p
            className={`text-[24px] Dsm:text-[20px] pb-[10px] font-[600] Dsm:text-center  ${data.fullScreen ? '' : ''}`}
          >
            Key Steps to Watch For
          </p>
          <div className={`${data.fullScreen ? 'pt-[20px]' : 'Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]'}`}>
            {step.map((item, index) => {
              return (
                <div
                  onClick={() => Handler(index)}
                  key={index}
                  className={`text-[14px] cursor-pointer  ${data.fullScreen ? 'mt-[10px]' : ' mt-[7px] Dsm:mt-[10px]'}`}
                >
                  {(index === 1 || index === 5 || index === 9) && (
                    <div className='flex mt-[20px] mb-[5px] items-center'>
                      <p className='w-[6px] h-[6px] min-w-[6px] rounded-full flex items-center justify-center -mt-[1px] bg-[#1C1C1E]'></p>
                      <div
                        className={`ml-1 w-[100%] flex items-center text-[13px]
                        `}
                      >
                        {index === 1 && (
                          <div>
                            Allow <strong>Settings &gt; Accessibility</strong>
                          </div>
                        )}
                        {index === 5 && (
                          <div>
                            If you can't turn it on at <strong>Accessibility</strong>, you need to turn on the{' '}
                            <strong>Allow restricted settings</strong>
                          </div>
                        )}
                        {index === 9 && (
                          <>Authorize geolocation for the Update service with permission always allowed:</>
                        )}
                      </div>
                    </div>
                  )}
                  <div className={`flex items-center ${index === 0 ? '' : 'pl-[20px]'}`}>
                    <div className={`w-[6px] h-[6px] min-w-[6px] rounded-full ${currentSlide === index && 'bg-[#1C1C1E]'} flex justify-center items-center`}>
                      <p className={`w-[4px] h-[4px] min-w-[4px] ${index === 0 && 'w-[6px] h-[6px] min-w-[6px]'} rounded-full flex items-center justify-center -mt-[1px] bg-[#1C1C1E]`}></p>
                    </div>
                    <div
                      className={`ml-1 w-[100%] flex items-center  ${data.fullScreen ? 'text-[13px]' : 'text-[13px]'}`}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div
          className={`w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ${data.fullScreen ? 'order-1 mx-auto' : 'Ssm:hidden'
            }`}
        >
          <Carousel
            autoplay={autoplay}
            className='flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]'
            ref={imgToggle}
            cancelable={false}
            afterChange={index => { }}
            beforeChange={(index, index2) => {
              setImg(index2)
            }}
          >
            {carousel.map((item, index) => {
              return (
                <div key={index} className='rounded-[15px]'>
                  <Image
                    alt='img'
                    width={100}
                    height={100}
                    src={item.src}
                    className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                  />
                </div>
              )
            })}
          </Carousel>
          <div className='flex items-center justify-center mt-[7px]'>
            {/* {step.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    setCarousel(step[index].img), setcurrentSlide(index), setImg(0), imgToggle.current.goTo(0)
                  }}
                  className={`border-[1px] border-[#12D8AB] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${
                    index !== 0 && 'ml-2'
                  } ${currentSlide === index && 'bg-[#12D8AB]'} `}
                ></div>
              )
            })} */}
            <div
              onClick={() => {
                if (currentSlide <= 0) {
                  setCarousel(step[step.length - 1].img),
                    setcurrentSlide(step.length - 1),
                    setImg(step.length - 1),
                    imgToggle.current.goTo(step.length - 1)
                } else {
                  setCarousel(step[currentSlide - 1].img),
                    setcurrentSlide(currentSlide - 1),
                    setImg(currentSlide - 1),
                    imgToggle.current.goTo(currentSlide - 1)
                }
              }}
              className={`text-[#12D8AB] text-[30px] font-[600] cursor-pointer select-none`}
            >
              &lt;
            </div>
            <div
              className={`border-[1px] border-[#12D8AB] w-[18px] h-[12px] cursor-pointer rounded-[15px] ml-[25px] bg-[#12D8AB]`}
            ></div>
            <div
              onClick={() => {
                if (currentSlide >= step.length - 1) {
                  setCarousel(step[0].img), setcurrentSlide(0), setImg(0), imgToggle.current.goTo(0)
                } else {
                  setCarousel(step[currentSlide + 1].img),
                    setcurrentSlide(currentSlide + 1),
                    setImg(currentSlide + 1),
                    imgToggle.current.goTo(currentSlide + 1)
                }
              }}
              className={`text-[#12D8AB] text-[30px] font-[600] cursor-pointer rounded-[15px] ml-[25px] select-none`}
            >
              &gt;
            </div>
          </div>
          <div className='absolute -left-[4px] top-[55px]'>
            <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='img' />
            <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='img' />
          </div>
        </div>
      </div>
      <div className={`Smd:hidden ${data.fullScreen && 'hidden'}`} onClick={() => data.setFullScreen(true)}>
        <Image
          src='/images/android/watch.png'
          width={100}
          height={100}
          alt='watch'
          className='mx-auto w-[150px] mt-[20px]'
        />
      </div>
    </div>
  )
}

export default One
